(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationSearchAddTraveler',
	};

	var $form;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		// Toggle client type select box
		$form.find('.client-type').on('change', function change(e) {
			if ($(e.target).val() === 'new') {
				$form.find('.existing-client').addClass('hidden');
				$form.find('.new-client').removeClass('hidden');
			} else {
				$form.find('.new-client').addClass('hidden');
				$form.find('.existing-client').removeClass('hidden');
			}
		});

		// Existing client typeahead logic
		Adzuki.Typeahead(
			'#reservationsearchaddtraveler-existing_client_search',
			'/Searches/client',
			function select(item, $self) {
				if (typeof item.id !== 'undefined') {
					Adzuki.Erez.SearchAddTraveler.addTraveler({
						type     : 'other',
						client_id: item.id,
						name     : item.name,
					});
				}

				$self.val('');
			}
		);
	};

	form.success = function success(response)
	{
		// this is used if a new client is added and the agent entered an email address that is a dupe of another client in their franchise
		if (response['status'] === 'confirmation_prompt') {
			Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);

			return false;
		}

		if (!Adzuki.Form.hasError(response)) {
			Adzuki.Erez.SearchAddTraveler.addTraveler(response['data']);

			$form.find('.new-client-field').val('');

			$('#reservationsearchaddtraveler-neworexistingclient-0-newclient-new_client_no_middle_name').prop('checked', false);

			$('#reservationsearchaddtraveler-neworexistingclient-0-newclient-new_client_birthday_hidden').val('');

			$('#reservationsearchaddtraveler-neworexistingclient-0-client_type-0').click();

			Adzuki.StatusMessage('Success', 'New client successfully added.');
		}

		return false;
	};

}(jQuery, window.Adzuki || {}));
